webpackJsonp([159876105824858],{

/***/ 1527:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProtocolReminderInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"sent","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"unsendable","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"unsendableReason","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-protocol-reminder-input-00443ea27e5a38012fa5.js